import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TargetDetailsModalPage } from './target-details-modal.page';

const routes: Routes = [
  {
    path: '',
    component: TargetDetailsModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TargetDetailsModalPageRoutingModule {}
